import { encodeFilePath } from './filestore-request';

/**
 * Direct (proxied) URL for a file's raw bytes. The facade serves
 * `Content-Disposition: attachment` and resolves LFS pointers, so a plain
 * anchor pointing here downloads the real content. Mirrors apiRequest's
 * `/proxy/{target}` base for the filestore target.
 */
export const filestoreFileUrl = (
  orgId: string,
  repo: string,
  filePath: string,
  ref?: string,
): string => {
  const base = `/proxy/filestore/v1/orgs/${orgId}/repos/${encodeURIComponent(repo)}/files/${encodeFilePath(filePath)}`;
  return ref ? `${base}?ref=${encodeURIComponent(ref)}` : base;
};
